import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

interface UseEnableProductNfceMappingProps {
  productNfceMappingId: string
  onSuccess?: () => void
  onError?: (error: AxiosError) => void
}

export const useEnableProductNfceMapping = ({
  productNfceMappingId,
  onSuccess,
  onError,
}: UseEnableProductNfceMappingProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation<void, AxiosError, void>({
    mutationKey: ['enableProductNfceMapping', productNfceMappingId],
    mutationFn: () => privateAxios.put(`/product_nfce_mappings/${productNfceMappingId}/enable`),
    onSuccess,
    onError,
  })
}
